
import Vue, { PropType } from 'vue';
import { Tag } from '@interfaces/DiagramTypes'
import SanitizeConst from '@constants/SanitizeConst'

export default Vue.extend({
  name: 'DiagramTags',
  props: {
    tags: {
      type: Array as PropType<Tag[]>,
      default: () => { return [] }
    },
    tagsDisabled: {
      type: Boolean
    }
  },
  data() {
    return {
      whiteList: SanitizeConst.XSS_WHITE_LIST_TAG
    }
  },
  methods: {
    tagClicked: function (tag: Tag) {
      this.$router.push(`/community/see-all?q=${tag.name}&filter=tags&tagId=${tag.id}`);
    }
  },
})
